<script setup lang="ts">
import CustomModal from "@/components/CustomModal/CustomModal.vue";
import CustomButton from "@/components/Button/Button.vue";
import { useI18n } from 'vue-i18n';

const { open } = defineProps({
  open: {
    type: Boolean,
    required: true
  }
});

defineEmits(['on-close']);

const { t } = useI18n();
</script>

<template>
  <CustomModal :show="open" @on-close="$emit('on-close')">
    <div class="h-[745px] w-[831px]">
      <div class="flex flex-col p-5">
        <div class="cursor-pointer self-end" type="default" @click="$emit('on-close')">
          <img src="@/assets/icons/svg/Close_16x16.svg" alt="Close" width="18" />
        </div>
        <div class="px-14 pt-3.5 pb-14">
          <h1 class="responsive-title-6 font-semibold">{{ t('modal.addCrewMember') }}</h1>
          <div class="responsive-body-xsmall bg-notifications-pending py-2.5 px-5 mt-11">
            {{ t('modal.warning') }}
          </div>
          <div class="mt-8 grid grid-cols-2 gap-4">
            <VTextField :label="t('modal.firstName')" variant="underlined"></VTextField>
            <VTextField :label="t('modal.lastName')" variant="underlined"></VTextField>
            <VTextField :label="t('modal.nationality')" variant="underlined"></VTextField>
            <VTextField :label="t('modal.dob')" variant="underlined"></VTextField>
            <VTextField :label="t('modal.passportNumber')" variant="underlined"></VTextField>
            <VTextField :label="t('modal.passportExpiry')" variant="underlined"></VTextField>
            <div class="col-span-2 flex flex-row gap-6 items-end">
              <div>
                <div class="text-xs">{{ t('modal.passportPhoto') }}</div>
                <div class="responsive-body-xsmall text-black/40">{{ t('modal.fileTypes') }}</div>
              </div>
              <div class="flex flex-row items-center">
                <CustomButton :outlined="true" :rounded="true" class="h-7">{{ t('modal.browseFile') }}
                </CustomButton>
                <div class="responsive-body-xsmall text-black/40">{{ t('modal.noFileChosen') }}</div>
              </div>
            </div>
            <VTextField :label="t('modal.email')" variant="underlined"></VTextField>
            <VTextField :label="t('modal.phoneNumber')" variant="underlined"></VTextField>
            <div class="col-span-2">
              <VSwitch :label="t('modal.sailingLicense')" inset base-color="#000000" color="#000000"></VSwitch>
            </div>
            <div class="col-span-2 flex flex-row gap-6 items-end">
              <div>
                <div class="text-xs">{{ t('modal.sailingLicensePhoto') }}</div>
                <div class="responsive-body-xsmall text-black/40">{{ t('modal.fileTypes') }}</div>
              </div>
              <div class="flex flex-row items-center">
                <CustomButton :outlined="true" :rounded="true" class="h-7">{{ t('modal.browseFile') }}
                </CustomButton>
                <div class="responsive-body-xsmall text-black/40">{{ t('modal.noFileChosen') }}</div>
              </div>
            </div>
            <CustomButton type="black" :rounded="true" class="w-[92px]">{{ t('modal.addButton') }}</CustomButton>
          </div>
        </div>
      </div>
    </div>
  </CustomModal>
</template>

<style scoped></style>
